import { useCallback, useContext } from 'react';
import { genericError } from 'store/Layout';
import { UserContext } from 'contexts';
import { usersClient } from 'clients/users/usersClient';


export const useSignup = () => {

  const { login } = useContext(UserContext);

  const signupAndLogin = useCallback(async (formData) => {
    try {
      await login(formData?.email, formData?.password);
    } catch (error: any) {
      genericError(error);
      return Promise.reject();
    }
  }, [login]);

  const signupAndLoginInvitation = useCallback(async (formData) => {
    try {
      await usersClient.signupWithEmailAndPasswordInvitation(formData);
      await login(formData?.email, formData?.password);
    } catch (error: any) {
      genericError(error);
      return Promise.reject();
    }
  }, [login]);

  return {
    signupAndLogin,
    signupAndLoginInvitation,
  };
};
